import React, { useEffect, useState } from "react";
import { ReactComponent as PostmanLogo } from "../assets/logo-light-full.svg";
import { ReactComponent as EuroKargo } from "../assets/LOGOA.svg";
import classes from "./MainPageHeader.module.css";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as LoginHeader } from "../assets/ProfileLogo.svg";
import { ReactComponent as RegisterHeader } from "../assets/RegisterHeader.svg";
import { ReactComponent as PostmanLogoBlue } from "../assets/postmanLogoBlue.svg";
import { Button, Collapse, CollapseProps, Dropdown, Modal } from "antd";
import { Drawer, useMediaQuery } from "@mui/material";
import { ReactComponent as BurgerMenu } from "../assets/burger-menu.svg";
import { ReactComponent as BurgerMenuBlue } from "../assets/burger-menu-blue.svg";
import DefaultInput from "./form/DefaultInput";
import { toast } from "react-toastify";
import api from "../utils/axios";
import { getConfigurationValue } from "../lib/OptionListApi";

interface MainPageHeaderProps {
	textColor?: string;
}

const MainPageHeader: React.FC<MainPageHeaderProps> = ({
	textColor = "black",
}) => {
	const location = useLocation();
	const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [message, setMessage] = useState("");

	const items = [
		{
			label: <Link to="/mainpage-notifications">Njoftimet</Link>,
			key: "item-1",
		},
		// {
		// 	label: <Link to="/activities">Aktivitetet</Link>,
		// 	key: "item-2",
		// },
		{
			label: <Link to="/partners">Partnerët tanë</Link>,
			key: "item-3",
		},
		// {
		// 	label: <Link to="/staff">Stafi</Link>,
		// 	key: "item-3",
		// },
		{
			label: <Link to="/tos">Kushtet e sherbimit</Link>,
			key: "item-4",
		},
		{
			label: <Link to="/faq">FAQ</Link>,
			key: "item-5",
		},
	];

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth >= 1550) {
				setMobileMenuOpen(false);
			}
		};

		window.addEventListener("resize", handleResize);

		handleResize();

		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		setMobileMenuOpen(false);
	}, [location]);

	const handleMobileMenuToggle = () => {
		setMobileMenuOpen(!isMobileMenuOpen);
	};

	const itemsDrawer: CollapseProps["items"] = [
		{
			key: "1",
			label: (
				<Link to="/for-us">
					<p>Per ne</p>
				</Link>
			),
			children: (
				<div className="flex flex-col text-white gap-2 text-base">
					<Link to="/mainpage-notifications">Njoftimet</Link>
					{/* <Link to="/activities">Aktivitetet</Link> */}
					<Link to="/partners">Partnerët tanë </Link>
					<Link to="/tos">Kushtet e sherbimit</Link>
					<Link to="/faq">FAQ</Link>
				</div>
			),
		},
	];

	const isMainPage = location.pathname === "/main";

	const isSmallScreen = useMediaQuery("(max-width: 600px)");
	const isMediumScreen = useMediaQuery("(max-width: 768px)");
	const isLargeScreen = useMediaQuery("(max-width: 994px)");
	const isLargerScreen = useMediaQuery("(max-width: 1200px)");

	const [isModalOpen, setIsModalOpen] = useState(false);

	const [configurationId, setConfigurationId] = useState<number | undefined>(
		undefined
	);

	const fetchConfiguration = async () => {
		const countryConfigurationValue = await getConfigurationValue(2);
		const countryValue = Number(countryConfigurationValue);
		setConfigurationId(countryValue);
	};

	useEffect(() => {
		fetchConfiguration();
	}, []);

	const cleanState = () => {
		setMessage("");
		setName("");
		setPhone("");
		setEmail("");
	};

	const sendComplaint = async () => {
		if (!name || !email || !phone || !message) {
			toast.error("Ju lutemi plotësoni të gjitha fushat e kërkuara.");
			return;
		}

		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!emailPattern.test(email)) {
			toast.error("Ju lutemi vendosni një email të vlefshëm.");
			return;
		}

		const phonePattern = /^\d+$/;
		if (!phonePattern.test(phone)) {
			toast.error(
				"Ju lutemi vendosni një numër telefoni të vlefshëm pa karaktere jo-numerike."
			);
			return;
		}

		const emailData = {
			to: "info@postman-ks.com",
			subject: "Ankesë klienti",
			body: `${message}\n\n${name}\n${phone}\n${email}`,
		};

		try {
			const response = await api.post("message/send-email", emailData, {
				headers: { "Content-Type": "application/json" },
			});
			cleanState();
			toast.success("Ankesa u dërgua me sukses!");
			setIsModalOpen(false);
		} catch (error) {
			toast.error("Failed to send complaint");
			console.error(error);
		}
	};

	return (
		<>
			<div
				className={classes.mainContainer}
				// style={{ background: isMainPage ? "#4f16c2" : "white" }}
			>
				<div className={classes.burgerDiv}>
					<BurgerMenu
						onClick={handleMobileMenuToggle}
						className="burgerMenu"
					/>
				</div>
				<div className={classes.heroContainer}>
					<div className={classes.postmanlogoDrawer}>
						{configurationId === 3 ? (
							<EuroKargo className={classes.postmanDrawer} />
						) : (
							<PostmanLogo className={classes.postmanDrawer} />
						)}
					</div>

					<div
						className={classes.links}
						// style={{ color: isMainPage ? "white" : "black" }}
					>
						<Link to="/main">
							<p>Ballina</p>
						</Link>
						{/* <Link to="/">
							<p>Per ne</p>
						</Link> */}
						<Dropdown menu={{ items }}>
							<Link to="/for-us">
								<p className="!text-white ">Per ne</p>
							</Link>
						</Dropdown>
						<Link to="/pricelist">
							<p>Çmimi</p>
						</Link>
						<Link to="/contact">
							<p>Kontakti</p>
						</Link>
						{/* <Link to="https://shop.postman-ks.com/">
							<p>Shop</p>
						</Link> */}
						<Link to="/mobileapp">
							<p>Mobile App</p>
						</Link>
						<Button
							onClick={() => setIsModalOpen(true)}
							className={classes.ankesaButton}
						>
							Ankesat klient
						</Button>
					</div>
					<div className={classes.loginRegisterButtons}>
						<Link to={"/login"}>
							<div className={classes.profileLogosLogin}>
								Kyçu
								<LoginHeader color="red" />
							</div>
						</Link>
						<Link to={"/register"}>
							<div className={classes.profileLogosRegister}>
								Regjistrohu
								<RegisterHeader color="red" />
							</div>
						</Link>
					</div>
				</div>
			</div>
			<div>
				{isMobileMenuOpen && (
					<div className="mobileMenu">
						<Drawer
							open={isMobileMenuOpen}
							onClose={handleMobileMenuToggle}
							className="drawer"
							PaperProps={{
								sx: {
									backgroundColor: "#4f16c2",
									color: "blue",
									width: isSmallScreen
										? "60%"
										: isMediumScreen
										? "65%"
										: isLargeScreen
										? "50%"
										: isLargerScreen
										? "40%"
										: "65%",
									padding: "2rem",
									gap: "3rem",
									height: "100%",
									"& .drawerLinks": {
										display: "flex",
										flexDirection: "column",
										gap: "2rem",
										color: "white",
										fontSize: "large",
									},
									"& .css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root":
										{
											minWidth: "10px",
											paddingLeft: 0,
											display: "flex",
											gap: "10px",
										},
									"& .css-10hburv-MuiTypography-root": {
										minWidth: "auto",
										fontSize: "large",
									},
									"& .css-cveggr-MuiListItemIcon-root": {
										minWidth: "10px",
										fontSize: "large",
									},
								},
							}}
						>
							<div className={classes.drawerContent}>
								<BurgerMenu
									onClick={handleMobileMenuToggle}
									className={classes.burgerMenu}
								/>
								<div className={classes.postmanlogoDrawer}>
									{configurationId === 3 ? (
										<EuroKargo
											className={classes.postmanDrawer}
										/>
									) : (
										<PostmanLogo
											className={classes.postmanDrawer}
										/>
									)}
								</div>
								<div className={classes.linksDrawer}>
									<Link to="/main">
										<p>Ballina</p>
									</Link>

									{/* <Dropdown menu={{ items }}>
										<Link to="/for-us">
											<p>Per ne</p>
										</Link>
									</Dropdown> */}
									<Collapse
										items={itemsDrawer}
										bordered={false}
										expandIconPosition="end"
									/>
									<Link to="/pricelist">
										<p>Çmimi</p>
									</Link>
									<Link to="/contact">
										<p>Kontakti</p>
									</Link>
									{/* <Link to="https://shop.postman-ks.com/">
										<p>Shop</p>
									</Link> */}
									<Link to="/mobileapp">
										<p>Mobile App</p>
									</Link>
									<Button
										className={classes.ankesaButton}
										onClick={() => {
											setMobileMenuOpen(false);
											setIsModalOpen(true);
										}}
									>
										Ankesat klient
									</Button>
								</div>
								<div
									className={
										classes.loginRegisterButtonsDrawer
									}
								>
									<Link to={"/login"}>
										<div
											className={
												classes.profileLogosLogin
											}
										>
											Kyçu
											<LoginHeader color="red" />
										</div>
									</Link>
									<Link to={"/register"}>
										<div
											className={
												classes.profileLogosRegister
											}
										>
											Regjistrohu
											<RegisterHeader color="red" />
										</div>
									</Link>
								</div>
							</div>
						</Drawer>
					</div>
				)}
			</div>
			<Modal
				title="Ankesat klient"
				open={isModalOpen}
				onOk={sendComplaint}
				onCancel={() => {
					cleanState();
					setIsModalOpen(false);
				}}
				okButtonProps={{
					style: { backgroundColor: "#4f16c2", color: "white" },
				}}
				okText="Dërgo"
				cancelText="Anulo"
			>
				<div className={classes.inputContainer}>
					<DefaultInput
						className={classes.input}
						label="Emri dhe Mbiemri"
						placeholder="Emri dhe Mbiemri"
						value={name}
						onChange={(e) => setName(e.target.value)}
					/>
					<DefaultInput
						className={classes.input}
						label="Email"
						placeholder="Email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<DefaultInput
						className={classes.input}
						label="Numri i telefonit"
						placeholder="Numri i telefonit"
						value={phone}
						onChange={(e) => setPhone(e.target.value)}
						type="number"
					/>
					<DefaultInput
						className={classes.input}
						label="Ankesa"
						placeholder="Ankesa..."
						value={message}
						onChange={(e) => setMessage(e.target.value)}
					/>
				</div>
			</Modal>
		</>
	);
};

export default MainPageHeader;
